import React from "react";
import {DashboardWidgets} from "./DashboardWidgets";

export default function DashboardIndex() {
    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <DashboardWidgets className="card-stretch gutter-b"/>
            </div>
        </div>
    )

}